import c from "classnames";
import { useViewTransitionState } from "react-router";

import { useMainLayoutProvider } from "@providers/MainLayoutProvider/useMainLayoutProvider";

import { Box } from "@design-system/Box/Box";
import { NavigationItem } from "@design-system/NavigationItem/NavigationItem";
import { Text } from "@design-system/Text/Text";

import { routes } from "@pages/routes";

import { useUserRole } from "@utils/hooks/useUserRole";

import classes from "./OrganizationMenu.module.css";

export const OrganizationMenu = () => {
  const { closeMobileNavigation } = useMainLayoutProvider();
  const { hasAffireAdminRole } = useUserRole();
  const isTransitioning = useViewTransitionState(
    `${routes.portal.clients.client.$path()}/:something`,
  );

  return (
    <nav className={c(classes.nav, !isTransitioning && classes.static)}>
      <Box direction="column" stretch>
        <Box direction="column" gap={2} fullWidth>
          <Box padding="0 24px 8px 24px">
            <Text
              color="textSecondary"
              size={12}
              spacing="relaxed"
              weight={700}
              uppercase
            >
              Organization
            </Text>
          </Box>
          <NavigationItem
            name="Dashboard"
            icon="faGrip"
            to={routes.portal.dashboard.$path()}
            onClick={closeMobileNavigation}
          />
          <NavigationItem
            name="Tenants"
            icon="faSuitcase"
            to={routes.portal.clients.$path()}
            onClick={closeMobileNavigation}
          />
          <NavigationItem
            name="Applications"
            icon="faShapes"
            to={routes.portal.applications.$path()}
            onClick={closeMobileNavigation}
          />
          <NavigationItem
            name="Staff"
            icon="faUserTie"
            to={routes.portal.users.$path()}
            onClick={closeMobileNavigation}
          />
          <NavigationItem
            name="Notifications"
            icon="faBell"
            to={routes.portal.notifications.$path()}
            onClick={closeMobileNavigation}
          />
          <NavigationItem
            name="Integrations"
            icon="faPlug"
            to={routes.portal.integrations.$path()}
            onClick={closeMobileNavigation}
          />
        </Box>

        {hasAffireAdminRole() && (
          <Box direction="column" gap={2} fullWidth>
            <Box padding="16px 24px 8px 24px">
              <Text
                color="textSecondary"
                size={12}
                spacing="relaxed"
                weight={700}
                uppercase
              >
                Administrative
              </Text>
            </Box>
            <NavigationItem
              name="Applications"
              icon="faShapes"
              to={routes.portal.administration.applications.$path()}
              onClick={closeMobileNavigation}
            />
            <NavigationItem
              name="Organizations"
              icon="faBuilding"
              to={routes.portal.administration.organizations.$path()}
              onClick={closeMobileNavigation}
            />
          </Box>
        )}
      </Box>
    </nav>
  );
};
